import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-test",
  "use": "icon-test-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-test\"><defs><style type=\"text/css\"></style></defs><path d=\"M745.017 45.966a38.836 38.836 0 0 1 0 77.673h-25.89v195.138a12.945 12.945 0 0 0 1.32 5.696L939.96 773.031c34.565 70.656 5.321 155.94-65.309 190.504a142.4 142.4 0 0 1-62.591 14.499H211.926c-78.643 0-142.4-63.756-142.4-142.4a142.4 142.4 0 0 1 14.5-62.59L303.54 324.46a12.945 12.945 0 0 0 1.32-5.696V123.64h-25.89a38.836 38.836 0 0 1-38.772-36.558l-0.052-2.279a38.836 38.836 0 0 1 38.836-38.836z m63.07 634.324h-592.2l-62.086 126.89a64.727 64.727 0 0 0 58.138 93.181h600.135a64.727 64.727 0 0 0 58.125-93.18l-62.1-126.891zM641.454 123.639H382.546v195.138a90.618 90.618 0 0 1-9.217 39.833L253.895 602.618h516.184l-119.408-244.02a90.618 90.618 0 0 1-9.217-39.808V123.64z\" p-id=\"16129\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/test.svg
// module id = fjDP
// module chunks = 52